import {userData} from '../../util/userData';
import {redirectToUrl} from '../UserAdministrationContainer/lib/utils';

export const buildHTMLSubtitle = (
  overall: string,
  net: string,
  netColor: string,
  avidLabel: string,
  surveyLabel: string,
  periodLabel: string,
  questionLabel: string,
  segment: string,
  segmentCategory: string,
  questionAbbr: string,
  questionId: string,
  questionValue: string,
  questionSmallText: string,
  drillToDrilldown: boolean,
  renderNetValue: boolean
) => {
  let segmentFragment = '';
  if (segment.length) {
    segmentFragment = ` | <small class="center-align">${segmentCategory}: ${segment}</small>`;
  }
  let netValue = ``;
  if (renderNetValue) {
    netValue = ` <small><span style="color: ${netColor} !important">(${net}%)</span></small>`;
  }
  if (drillToDrilldown) {
    return `
  <h5 class="center-align link" onclick="satisfactionDrill('${questionAbbr}', 'drilldown', '${questionId}', '${questionValue}', '${questionLabel}', '${questionSmallText}');">${overall}%${netValue}</h5>
  <small class="center-align">${avidLabel}</small> | <small class="center-align">${surveyLabel}</small> | <small class="center-align">${periodLabel}</small>${segmentFragment} | <small class="center-align">${questionLabel}</small>
`;
  } else {
    return `
    <h5 class="center-align link" >${overall}%${netValue}</h5>
  <small class="center-align">${avidLabel}</small> | <small class="center-align">${surveyLabel}</small> | <small class="center-align">${periodLabel}</small>${segmentFragment} | <small class="center-align">${questionLabel}</small>
    `;
  }
};

export const buildHTMLFiltersSubtitle = (
  avidLabel: string,
  surveyLabel: string,
  periodLabel: string,
  segment: string,
  segmentCategory: string,
  question: string,
  commentType: string
) => {
  let avidFragment = '';
  if (avidLabel && avidLabel.length) {
    avidFragment = `<small class="center-align">${avidLabel}</small>`;
  }
  let segmentFragment = '';
  if (segment && segment.length > 0) {
    segmentFragment = ` | <small class="center-align">${segmentCategory}: ${segment}</small>`;
  }
  let questionFragment = '';
  if (question && question.length) {
    questionFragment = ` | <small class="center-align">${question}</small>`;
  }
  let commentTypeFragment = '';
  if (commentType && commentType.length) {
    commentTypeFragment = ` | <small class="center-align">${commentType}</small>`;
  }
  let surveyFragment = '';
  if (surveyLabel && surveyLabel.length) {
    surveyFragment = ` | <small class="center-align">${surveyLabel}</small>`;
  }
  return `
  ${avidFragment}
  ${segmentFragment}
  ${questionFragment}
  ${commentTypeFragment}
  ${surveyFragment}
`;
};
export const buildFiltersSubtitle = (
  avidLabel: string,
  surveyLabel: string,
  periodLabel: string,
  segment: string,
  segmentCategory: string,
  question: string,
  commentType: string
) => {
  let avidFragment = '';
  if (avidLabel && avidLabel.length) {
    avidFragment = `${avidLabel}`;
  }
  let segmentFragment = '';
  if (segment && segment.length > 0) {
    segmentFragment = ` | ${segmentCategory}: ${segment}`;
  }
  let questionFragment = '';
  if (question && question.length) {
    questionFragment = ` | ${question}`;
  }
  let commentTypeFragment = '';
  if (commentType && commentType.length) {
    commentTypeFragment = ` | ${commentType}`;
  }
  let surveyFragment = '';
  if (surveyLabel && surveyLabel.length) {
    surveyFragment = ` | ${surveyLabel}`;
  }
  return `
  ${avidFragment}
  ${segmentFragment}
  ${questionFragment}
  ${commentTypeFragment}
  ${surveyFragment}
`;
};

export const drilldownClickHandler = (a, h, pa, ph, ip, de, ds, c) => {
  const filters = userData.getFilters();

  //NOTE: If color = #FFD700 Then Go UP.
  //NOTE: If not, Go Down
  //NOTE: If de, go to coaching form
  //NOTE: If ds, reload
  if (c === '#FFD700' || ds === h.trim()) {

    filters.hier = ph.trim();
    filters.avid = pa.trim();
    $('#hiers').val(pa.trim());
    userData.updateFilters(filters, true);
  } else if (de !== a.trim()) {
    filters.hier = h.trim();
    filters.avid = a.trim();
    $('#hiers').val(a.trim());
    userData.updateFilters(filters, true);
  } else {
    filters.hier = h.trim();
    filters.avid = a.trim();
    userData.updateFilters(filters, true);
    redirectToUrl('coachingoverview');
  }

  // loadVisualizations(filters, true);
}

/**
 * @param height
 * @param title
 * @param subtitle
 * @param categories
 * @param series
 */
export const setCommentTrendChartOptions = (
  height: number,
  title: string,
  subtitle: string,
  categories: string[],
  series: any[],
) => {
  let formattedTitle;
  if (!title.length) {
    formattedTitle = {
      style: {
        display: 'none'
      }
    }
  } else {
    formattedTitle = {
      useHTML: true,
      text: title,
      x: 0,
      y: 5,
      align: 'left'
    }
  }

  let formattedSubtitle;
  if (subtitle.length) {
    formattedSubtitle = {
      useHTML: true,
      text: subtitle,
      align: 'middle'
    }
  }

  let minimumHeight = 300;
  if (height > 0) {
    minimumHeight = height;
  }
  return {
    lang: {
      noData: 'There are no comment sentiments that meet the selected criteria',
    },
    chart: {
      height: minimumHeight,
    },
    title: formattedTitle,
    subtitle: formattedSubtitle,
    xAxis: {
      categories,
    },
    yAxis: {
      title: null,
      labels: {
        enabled: false,
      },
    },
    tooltip: {},
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    series,
    exporting: {
      chartOptions: {
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        subtitle: {
          useHTML: false,
          style: {
            fontSize: '8px',
          },
        },
        legend: {
          enabled: true,
        },
      },
      buttons: {
        contextButton: {
          symbol: 'url(images/bars.png)',
        },
      },
    },
    plotOptions: {
      series: {
        marker: {
          enabled: true
        }
      }
    },
    navigation: {
      buttonOptions: {
        verticalAlign: 'top',
        y: -10,
      },
    },
  };
};
